import React, { useState } from "react";
import search_icon from "../assets/icons/search_icon.png";

const ExhibitionFilter = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="mt-4 border h-screen rounded-md p-2">
      <div className="text-[16px] text-[#828282]">FILTERS</div>
      <p className="text-[#828282] text-[12px] mt-3">
        Search States/Designation
      </p>
      <div className="flex border border-[#95C2FF] rounded-lg">
        <img
          src={search_icon}
          alt="search icon"
          className="w-5 object-contain mx-1"
        />
        <input
          type="text"
          placeholder="Search state or designation"
          className="text-[12px] w-full p-2 rounded-lg"
        />
      </div>
      <div className="mt-2">
        <div
          onClick={toggleAccordion}
          style={{ cursor: "pointer" }}
          className="flex items-center justify-between"
        >
          <p className="text-[12px] font-bold">Location</p>

          <div
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0)",
            }}
            className="text-[30px] pr-2"
          >
            &#8964; {/* Down arrowhead*/}
          </div>
        </div>

        {isOpen && (
          <div className="flex flex-col">
            <p className="text-[10px] mb-2">Types</p>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Maharashtra</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Gujarat</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Madhya Pradesh</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">West Bengal</p>
            </label>

            {/* Sub-Task Types */}
            <p className="text-[10px] mb-2 mt-2">City</p>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Mumbai</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Pune</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Nagpur</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Indore</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Bhopal</p>
            </label>
            <label className="flex mb-2">
              <input type="checkbox" />
              <p className="pl-2 text-[12px]">Kolkata</p>
            </label>
          </div>
        )}
      </div>

      <div
        style={{ cursor: "pointer" }}
        className="flex items-center justify-between"
      >
        <p className="text-[12px] font-bold">Designation</p>

        <div
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0)",
          }}
          className="text-[30px] pr-2"
        >
          &#8964; {/* Down arrowhead*/}
        </div>
      </div>

      <div className="flex justify-between mt-2">
        <button className="p-2 text-[14px] font-bold text-[#2F80ED] border border-[#2F80ED] rounded-lg w-[49%]">
          Discard
        </button>
        <button className="p-2 text-[14px] font-bold bg-[#2F80ED] text-white rounded-lg w-[49%]">
          Apply
        </button>
      </div>
    </div>
  );
};

export default ExhibitionFilter;
